import { render, staticRenderFns } from "./UnitInput.vue?vue&type=template&id=aff9cfe4&scoped=true&"
import script from "./UnitInput.vue?vue&type=script&lang=js&"
export * from "./UnitInput.vue?vue&type=script&lang=js&"
import style0 from "./UnitInput.vue?vue&type=style&index=0&id=aff9cfe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff9cfe4",
  null
  
)

export default component.exports